import React, { Fragment, useEffect, useRef } from 'react';
import { bool } from 'prop-types';

import Bride from '@assets/images/febri.png';
import Groom from '@assets/images/aldi.png';

import { styWrapper, revealAnimation } from './styles';

function HelloSection({ isInvitation }) {
  const sectionRef = useRef();
  const finalSubtitle = 'Kamis, 04 Desember 2025';

  useEffect(() => {
    const handleScroll = () => {
      const element = sectionRef.current;
      if (element) {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (elementTop < windowHeight * 0.8) {
          element.classList.add('reveal');
          
          // Animate child elements with staggered delays
          const textElements = element.querySelectorAll('h2, h3, p');
          textElements.forEach((el, i) => {
            el.style.transitionDelay = `${i * 0.1}s`;
            el.classList.add('reveal');
          });
          
          window.removeEventListener('scroll', handleScroll);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Fragment>
      <div id="fh5co-couple" css={styWrapper} ref={sectionRef} className={revealAnimation}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
              <h2 className="main-font">Assalamualaikum Wr. Wb</h2>
              <h3 className="sub-title hs">{finalSubtitle}</h3>
              <p className="info">
                Dengan memohon Rahmat dan Ridho Illahi, teriring niat menjalankan Sunnah Rasulullah ﷺ untuk membentuk
                rumah tangga yang Sakinah, Mawaddah wa Rahmah, kami mohon do'a agar senantiasa diberikan kelancaran dan
                keberkahan.
              </p>
            </div>
          </div>
          <div className="couple-wrap">
            <div className="couple-half">
             
              <div className="desc-groom">
                <h3 className="main-font">Yayuk Fadilah</h3>
                <p className="parent-name parent-name__top">
                Putri <b>Bapak Matki</b> <br />& <b>Ibu Rubiah</b>
                </p>
              </div>
            </div>
            <p className="heart text-center">
              <i className="icon-heart2"></i>
            </p>
            <div className="and-love">
              <i>&</i>
            </div>
            <div className="couple-half">
              
              <div className="desc-bride">
                <h3 className="main-font">Aji Bayu Santoso</h3>
                <p className="parent-name">
                  Putra <b>Bapak Sarno</b><br />& <b>Ibu Sulastri</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

HelloSection.propTypes = {
  isInvitation: bool.isRequired,
};

export default HelloSection;
